// import logo from '../../assets/HealthPerform_Logo_Dark.svg'
// import { useNavigate } from 'react-router';
import "./DefaultLayout.scss"
export const PageFooterComponent = () => {
    // const navigate = useNavigate()
    return(
        <footer className="page-footer">
            {/* <img src={logo} onClick={()=> navigate('/')} style={{width: '125px' ,display:'block', marginLeft: 'auto', marginRight: 'auto', cursor:'pointer'}}></img> */}
            <div style={{backgroundColor: 'black', textAlign: 'center', padding: '0.5rem'}}>
                <strong style={{color: 'white'}}>MyPBC Portal</strong>
            </div>
        </footer>
        
    )
}

export default PageFooterComponent